import Withdraws from '@/components/withdraws/Withdraws'
import WithdrawDetail from '@/components/withdraws/WithdrawDetail'
import WithdrawCreate from '@/components/withdraws/WithdrawCreate'

const withdrawsRoutes = [
  { path: '/withdraws', name: 'withdraws', component: Withdraws },
  { path: '/withdraw/create', name: 'withdraw_create', component: WithdrawCreate },
  { path: '/withdraw/:id', name: 'withdraw', component: WithdrawDetail }
]

export default withdrawsRoutes



// WEBPACK FOOTER //
// ./src/router/withdraws_routes.js